import { createSelector } from "reselect";
import { SortDirection as SD } from "react-virtualized";
import moment from "moment";
import { Set, List } from "immutable";

import { createLogicFilter } from "../Utilities";
import * as R from "ramda";
import { inferDataType } from "./utils";

// EW.
const DATE_FORMAT = "MM/DD/YYYY";

const orNA = R.mapObjIndexed((value, _key, _obj) => value || "N/A");

export const noObjects = R.pickBy((value, key) => typeof value !== "object");
export const toKVFragments = obj =>
  Object.keys(obj)
    .reduce((lst, k) => [...lst, `${k}:${obj[k]}`], [])
    .join("\t");
export const objToArr = row => R.filter(noObjects, R.values(row));
export const stringify = list => JSON.stringify(list);
export const sanitize = R.replace(/[",\[\]]/g, " ");

const show = (v, label = "v") => {
  console.log(`${label}=${v}`);
  return v;
};

// Basic State & Prop Mapper
export const filter = (state, props) => state.dataComponents.filter.get(props.dataName) || "";
export const crumb = (state, props) => state.dataComponents.crumb.get(props.dataName) || "";
export const sortBy = (state, props) => state.dataComponents.sortBy.get(props.dataName) || null;
// export const cursors = (state, props) => {
//   return state.dataComponents.cursors.get(props.dataName) || List();
// };
export const sortDirection = (state, props) => state.dataComponents.sortDirection.get(props.dataName) || null;
export const dataTransformer = (_, { dataTransformer = f => f }) => dataTransformer;
export const data = (_, { data }) => data;
export const SortDirection = (state, props) => (sortDirection(state, props) === 1 ? SD.ASC : SD.DESC);
export const columns = (state, props) => props.columns;

export const dateRange = (state, props) => state.dataComponents.dateFilter.dateRange;

// export const cursorCheck = createSelector(
//   cursors,
//   cursors => {
//     let set = Set();

//     cursors.forEach(([c, r]) => {
//       set = set.add(`${c}:${r}`);
//     });

//     return ([c, r]) => set.has(`${c}:${r}`);
//   }
// );

export const columnOrder = createSelector(
  columns,
  columns => columns.reduce((a, c) => [...a, c.dataKey], [])
);

export const flattenRow = columnOrder => row => {
  let output = [];
  for (let name of columnOrder) {
    output.push(row[name]);
  }
  return output;
};

export const inflateRow = columnOrder => row => {
  let output = {};
  for (let i = 0; i < columnOrder.length; i++) {
    output[columnOrder[i]] = row[i];
  }
  return output;
};

export const filteredData = createSelector(
  data,
  dataTransformer,
  filter,
  sortBy,
  sortDirection,
  dateRange,
  (data, dataTransformer, filter = "", sortBy = null, sortDirection = null, dateRange) => {
    let output = [];
    const filterFunction = createLogicFilter(filter);

    const transformationPipe = R.pipe(
      dataTransformer,
      orNA
    );

    output = data.map(transformationPipe);

    // NOTE: Used for testing. Un-comment when you want the data size to be smaller.
    // output = output.slice(0, 20);

    // TODO: Refactor this bologna.
    if (dateRange) {
      let after = moment(dateRange.after, DATE_FORMAT);
      let before = moment(dateRange.before, DATE_FORMAT);
      let columnName = null;

      output = output.filter(row => {
        if (!columnName)
          for (const name in row) {
            if (/date/.test(name.toLowerCase())) {
              columnName = name;
              break;
            }
          }

        const rowDate = moment(row[columnName], DATE_FORMAT);

        return rowDate.diff(after) > 0 && rowDate.diff(before) < 0;
      });
    }

    // filter  row( values -> filterObjects ) -> stringify -> replace -> filterFunction
    output = R.filter(
      R.pipe(
        noObjects,
        toKVFragments,
        filterFunction
      ),
      output
    );

    // Filter after human readable formatting has taken place.
    // output = output.filter(row => filterFunction(JSON.stringify(R.values(row)).replace(/[",\[\]]/g, " ")));

    // Sort when the length of the list is shorter.
    if (sortBy != null && sortDirection != null)
      output.sort((a, b) => {
        const { a: valueA, b: valueB } = inferDataType({ a: a[sortBy], b: b[sortBy] });

        if (valueA < valueB) return -1 * sortDirection;
        if (valueA > valueB) return 1 * sortDirection;

        return 0;
      });

    return output;
  }
);

export const tableRows = createSelector(
  filteredData,
  columnOrder,
  filter,
  (data, columnOrder, filter) => {
    data = data.map(flattenRow(columnOrder));
    data.unshift(columnOrder);
    return data;
  }
);
